import { Divider, Drawer, Grid, Typography } from '@material-ui/core';
import { SmSpace, TextField, Button } from 'm2m.components';
import React, { useEffect, useState } from 'react';
import UploadDocs, { Attachment } from './uploadDocs';

interface Props {
  open: boolean;
  onClose(): void;
  onSubmit?(justificativa: string, anexos: Array<Attachment>): Promise<void>;
  justificativaObrigatoria: boolean;
  overrideTitle?: string;
  overrideSubmitButtonText?: string;
  overrideSubmitButtonColor?: 'inherit' | 'primary' | 'secondary' | 'default' | 'error';
}

export const JustificativaAnexoDrawer: React.FC<Props> = (props) => {
  const {
    open,
    onClose,
    onSubmit,
    justificativaObrigatoria,
    overrideTitle,
    overrideSubmitButtonText,
    overrideSubmitButtonColor,
  } = props;
  const [justificativa, setJustificativa] = useState<string>('');
  const [anexos, setAnexos] = useState<Array<Attachment>>([]);
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [fulfilled, setFulfilled] = useState<boolean>(!justificativaObrigatoria);

  const handleRemoveClick = (id: string) => {
    const updatedAnexos = anexos.filter((anexo) => anexo.id !== id);
    setAnexos(updatedAnexos);
  };

  const handleAnexosChange = (atts: Attachment[]) => {
    const updatedAnexos = anexos.concat(atts);
    setAnexos(updatedAnexos);
  };

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      if (!!onSubmit) {
        await onSubmit(justificativa, anexos);
      }
      onClose();
    } catch {
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    setJustificativa('');
    setAnexos([]);
  }, [open, setJustificativa, setAnexos]);

  useEffect(() => {
    if (justificativaObrigatoria) {
      setFulfilled(!!justificativa);
    }
  }, [justificativa, anexos, setFulfilled, justificativaObrigatoria]);

  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ style: { padding: '40px', width: 520 } }}>
      <Grid container>
        <Grid item sm={12}>
          <Typography variant="h3">{overrideTitle ?? `Justificativa`}</Typography>
          <SmSpace />
          <Divider variant="fullWidth" />
          <SmSpace />
          <TextField
            label="Justificativa"
            value={justificativa}
            rows={5}
            onChange={(value) => setJustificativa(value)}
            multiline
            fullWidth
            disabled={submitting}
          />
          <SmSpace />
          <UploadDocs onChange={handleAnexosChange} onDelete={handleRemoveClick} multipleFiles={true} />
          <SmSpace />
          <Button
            variant="contained"
            fullWidth
            color={overrideSubmitButtonColor ?? 'primary'}
            onClick={handleSubmit}
            disabled={submitting || (justificativaObrigatoria && !fulfilled)}
          >
            {overrideSubmitButtonText ?? 'Confirmar'}
          </Button>
          <SmSpace />
          <Button variant="outlined" fullWidth onClick={onClose} disabled={submitting}>
            {'Cancelar'}
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  );
};
